import c from "react";
import { useKioskLanding as d } from "../../context.js";
import n from "./kioskButton.module.scss.js";
function k({
  type: s,
  onClick: t,
  children: e
}) {
  const { configuration: o } = d(), r = s === "primary" ? (o == null ? void 0 : o.common.design.colors.buttonBackground) || "#ea565c" : (o == null ? void 0 : o.common.design.colors.secondaryButtonBackground) || "#f5f5f5", m = s === "primary" ? (o == null ? void 0 : o.common.design.colors.buttonText) || "#FFFFFF" : (o == null ? void 0 : o.common.design.colors.secondaryButtonText) || "#242c30";
  return /* @__PURE__ */ c.createElement(
    "div",
    {
      "data-testid": "kiosk-button",
      className: n.kioskButton,
      onClick: () => t == null ? void 0 : t(),
      style: {
        "--background": r,
        "--color": m
      }
    },
    e
  );
}
export {
  k as KioskButton
};
//# sourceMappingURL=KioskButton.js.map
